/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'

import { COLUMN_NAMES, DueOutFetchArgs } from '../../assets/ts/data/dueout/dueout'
import { InquiryFetchArgs } from '../../assets/ts/data/inquiry/inquiry'
import Buttons from '../../components/buttons/buttons'
import { MetadataContext } from '../../store/metadata-context-provider'
import { ALL_SELECT_OPTION, ALL_SELECT_OPTION_STRING, NONE_SELECT_OPTION, NONE_SELECT_OPTION_STRING } from '../../utils/constants/global-constants'
import CustomSelect from '../../utils/controls/custom-select'
import { ModeType } from './admin-view'

interface Props {
  availableFilterValues: Map<string,  number[] | string[]>
  dueOutFilter: DueOutFetchArgs
  filter : DueOutFetchArgs | InquiryFetchArgs
  inquiryFilter: InquiryFetchArgs
  mode: ModeType
  onClearAll: () => void
  onUpdateFilter:  (updatedArgs: any, order?: number)  => void
  selectedTab : number
  setMode: React.Dispatch<React.SetStateAction<ModeType>>
}
interface SelectOption {
  label: string
  value: null | number | string
}

interface FilterDropdown {
  CategoryCode?: SelectOption[]
  FY?: SelectOption[]
  SectionCode?: SelectOption[]
  ServicingBy?: SelectOption[]
  ServicingMAJCOMCode?: SelectOption[]
  ServicingOrganization?: SelectOption[]
}
let filterChanged = 0

const AdminDashboardFilters = ({
  availableFilterValues,
  filter,
  mode,
  onClearAll,
  onUpdateFilter,
  selectedTab,
  setMode,
}: Props) => {
  const metadataContext = useContext(MetadataContext)
  const [dropdownOptions, setDropdownOptions] = useState<FilterDropdown>({})
  const filterOrder = {
    CategoryCode: 9,
    FY: 1,
    NotCascading: 100,
    SectionCode: 8,
    ServicingBy: 4,
    ServicingMAJCOMCode: 3,
    ServicingOrganization: 5,
  }

  const filterValues = (name) => {
    return availableFilterValues?.get(name) ?? []
  }

  const filterChangedOrder = (e, selectorder: number) => {
    filterChanged = selectorder
  }
  const generateCodeOptionOnLength = (
    metadataOptions: SelectOption[],
    codes: (null | number)[]
  ) => {
    const options = metadataOptions.filter((option) => codes.includes(option.value as number))
    if (codes.includes(null)) {
      options.unshift({ label: '(Empty)', value: null })
    }
    return options.length === 0 
      ? [NONE_SELECT_OPTION]
      : options.length === 1
      ? options
      : [ALL_SELECT_OPTION, ...options]
  }

  const createCodeOptions = (
    filterChanged: number,
    threshold: number,
    dropdownOptions: SelectOption[],
    metadataOptions: SelectOption[],
    codes: number[]
  ) => {
    return filterChanged >= threshold
      ? dropdownOptions
      : generateCodeOptionOnLength(metadataOptions, codes)
  }
  const generateStringOptionOnLength = (values: string[]) => {
    const options = values.map((value) => ({
      label: value,
      value: value,
    }))
    if (options.length === 0) {
      return [NONE_SELECT_OPTION_STRING]
    }
    if ((filterChanged === 0 && options.length === 0)) {
      return [NONE_SELECT_OPTION]
    }
    if (options.length === 1) {
      return options
    }
    if (options.length > 1) {
      return [ALL_SELECT_OPTION_STRING, ...options]
    }
  }

  const createStringOptions = (
    filterChanged: number,
    threshold: number,
    dropdownOptions: SelectOption[],
    values: string[]
  ) => {
    if (filterChanged >= threshold) {
      return dropdownOptions
    }
    return generateStringOptionOnLength(values)
  }
useEffect(()=>{
  filterChanged = 0 
},[selectedTab])
  
  useEffect(() => {
    if (filterChanged >= 0 ) {
      const yearFilter: SelectOption[] = filterValues(COLUMN_NAMES.FY).map((v) => ({
        label: v,
        value: v,
      }))
      const yearOptions =
        (filterChanged === 0 && yearFilter.length === 0)
          ? [NONE_SELECT_OPTION]
          : filterChanged === 0
          ? [ALL_SELECT_OPTION, ...yearFilter]
          : dropdownOptions.FY
      // note : currently we dont have erd update for the majcomcode
      // so it works in a different way then other filters for inquires
      const majcomCodes = filterValues(COLUMN_NAMES.ServicingMAJCOMCode) as number[]
      const majcomOptions = createCodeOptions(
        filterChanged,
        filterOrder.ServicingMAJCOMCode,
        dropdownOptions.ServicingMAJCOMCode as SelectOption[],
        metadataContext.majcomOptions,
        majcomCodes
      )
      const servicingByValues = filterValues(COLUMN_NAMES.ServicingBy) as string[]
      const servicingByOptions = createStringOptions(
        filterChanged,
        filterOrder.ServicingBy,
        dropdownOptions.ServicingBy as SelectOption[],
        servicingByValues
      )

      const servicingOrganizationValues = filterValues(
        COLUMN_NAMES.ServicingOrganization
      ) as string[]
      const servicingOrganizationOptions = createStringOptions(
        filterChanged,
        filterOrder.ServicingOrganization,
        dropdownOptions.ServicingOrganization as SelectOption[],
        servicingOrganizationValues
      )
      const sectionCodes = filterValues(COLUMN_NAMES.SectionCode) as number[]
      const sectionOptions = createCodeOptions(
        filterChanged,
        filterOrder.SectionCode,
        dropdownOptions.SectionCode as SelectOption[],
        metadataContext.sectionOptions,
        sectionCodes
      )
      const categoryCodes = filterValues(COLUMN_NAMES.CategoryCode) as number[]
      const categoryOptions = createCodeOptions(
        filterChanged,
        filterOrder.CategoryCode,
        dropdownOptions.CategoryCode as SelectOption[],
        metadataContext.categoryOptions,
        categoryCodes
      )


      setDropdownOptions((prev) => ({
        ...prev,
        CategoryCode: categoryOptions as SelectOption[],
        FY: yearOptions as SelectOption[],
        SectionCode: sectionOptions as SelectOption[],
        ServicingBy: servicingByOptions as SelectOption[],
        ServicingMAJCOMCode: majcomOptions as SelectOption[],
        ServicingOrganization: servicingOrganizationOptions as SelectOption[],
      }))
    }
  }, [availableFilterValues, filterChanged])

  const handleInquiryDueOutToggle: React.ChangeEventHandler<
    HTMLInputElement
  > = (e) => {
    const checked = e.target.checked
    filterChanged = 0
    onClearAll()
    setMode(checked ? 'dueout' : 'inquiry' )
  }

  return (
    <div className='pb-2 ps-sm-3 d-flex flex-column flex-sm-row align-items-sm-center w-100 maxfitcontent-sm ms-auto dashboardfilters'>
      <div className='d-flex flex-wrap flex-column flex-sm-row justify-content-end gap-2'>
        <div className='filters hometoggle d-flex align-items-center'>
          <label
            aria-label='Inquiries'
            className='poppins-semibold font-12 title-color'
            htmlFor='toggleHome'
            tabIndex={0}
          >
            Inquiries
          </label>
          <label className='dueoutswitch'>
            <input
              aria-label='checkbox'
              checked={mode === 'dueout'}
              id='toggleHome'
              onChange={handleInquiryDueOutToggle}
              type='checkbox'
            />
            <span className='dueoutslider round'></span>
          </label>
          <label
            aria-label='Due Outs'
            className='poppins-semibold font-12 subtitle-color dimmed'
            htmlFor='toggleHome'
            tabIndex={0}
          >
            Due Outs
          </label>
        </div>
        <CustomSelect
          className='form-sm w-100 max-w-80 min-w-80 sourcesanspro font-13 customselect'
          formClassName='form-horizontal  dash poppins-semibold font-11'
          id='Year'
          label='Year'
          name='Year'
          onChange={(e) => {
            onUpdateFilter(
              {
                yearFilter: e.value,
              },
              filterOrder.FY
            )
            filterChangedOrder(e, filterOrder.FY)
          }}
          options={dropdownOptions.FY}
          value={
            dropdownOptions.FY?.length === 2 ? dropdownOptions.FY[1].value : filter.yearFilter
          }
        />

        <CustomSelect
          className='form-sm w-100 max-w-80 min-w-80 sourcesanspro font-13 customselect'
          formClassName='form-horizontal dash poppins-semibold font-11'
          id='ServicingMAJCOM'
          label='Servicing MAJCOM'
          name='ServicingMAJCOM'
          onChange={(e) => {
            onUpdateFilter(
              { servicingMAJCOMCodeFilter: e.value },
              filterOrder.ServicingMAJCOMCode
            )
            filterChangedOrder(e, filterOrder.ServicingMAJCOMCode)
          }}
          options={dropdownOptions.ServicingMAJCOMCode}
          value={
            dropdownOptions.ServicingMAJCOMCode?.length === 1
              ? dropdownOptions.ServicingMAJCOMCode[0].value
              : filter.servicingMAJCOMCodeFilter
          }
        />
        <CustomSelect
          className='form-sm w-100 max-w-80 min-w-80 sourcesanspro font-13 customselect'
          formClassName='form-horizontal dash poppins-semibold font-11'
          id='CurrentServicingUnit'
          label='Current Servicing Unit'
          name='Current Servicing Unit'
          onChange={(e) => {
            onUpdateFilter(
              {
                servicingByFilter: e.value,
              },
              filterOrder.ServicingBy
            )
            filterChangedOrder(e, filterOrder.ServicingBy)
          }}
          options={dropdownOptions.ServicingBy}
          value={
            dropdownOptions.ServicingBy?.length === 1
              ? dropdownOptions.ServicingBy[0].value
              : filter.servicingByFilter
          }
        />
        <CustomSelect
          className='form-sm w-100 max-w-80 min-w-80 sourcesanspro font-13 customselect'
          formClassName='form-horizontal dash poppins-semibold font-11'
          id='ServicingOrganization'
          label='Servicing Organization'
          name='Servicing Organization'
          onChange={(e) => {
            onUpdateFilter(
              { servicingOrganizationFilter: e.value },
              filterOrder.ServicingOrganization
            )

            filterChangedOrder(e, filterOrder.ServicingOrganization)
          }}
          options={dropdownOptions.ServicingOrganization}
          value={
            dropdownOptions.ServicingOrganization?.length === 1
              ? dropdownOptions.ServicingOrganization[0].value
              : filter.servicingOrganizationFilter
          }
        />
        <CustomSelect
          className='form-sm w-100 max-w-80 min-w-80 sourcesanspro font-13 customselect'
          formClassName='form-horizontal dash poppins-semibold font-11'
          id='Section'
          label='Section'
          name='Section'
          onChange={(e) => {
            onUpdateFilter(
              {
                sectionCodeFilter: e.value,
              },
              filterOrder.SectionCode
            )
            filterChangedOrder(e, filterOrder.SectionCode)
          }}
          options={dropdownOptions.SectionCode}
          value={
            dropdownOptions.SectionCode?.length === 1
              ? dropdownOptions.SectionCode[0].value
              : filter.sectionCodeFilter
          }
        />
        <CustomSelect
          className='form-sm w-100 max-w-80 min-w-80 sourcesanspro font-13 customselect'
          formClassName='form-horizontal dash poppins-semibold font-11'
          id='Category'
          label='Category'
          name='Category'
          onChange={(e) => {
            onUpdateFilter(
              {
                categoryCodeFilter: e.value,
              },
              filterOrder.CategoryCode
            )
            filterChangedOrder(e, filterOrder.CategoryCode)
          }}
          options={dropdownOptions.CategoryCode}
          value={
            dropdownOptions.CategoryCode?.length === 1
              ? dropdownOptions.CategoryCode[0].value
              : filter.categoryCodeFilter
          }
        />
      </div>
      <Buttons
        aria-label='Clear All'
        className='btn btn-sm links ms-auto ms-sm-0 ms-md-0  links-underline text-nowrap'
        label='Clear All'
        onClick={onClearAll}
      />
    </div>
  )
}
export default AdminDashboardFilters
